import React from 'react';
import {
  arrayOf,
  shape,
  string,
  func,
} from 'prop-types';
import { Option } from 'components/common';

import './SelectPanel.scss';

const SelectPanel = ({ options, onChange, dataSelectorId }) => (
  <div className="select-panel" data-selector={dataSelectorId}>
    {options.map(({ label, value }) => (
      <Option
        key={value}
        className="select-panel-option"
        dataSelectorId={`option-${value}`}
        onClick={() => {
          if (onChange) onChange({ label, value });
        }}
      >
        {label || value}
      </Option>
    ))}
  </div>
);

SelectPanel.propTypes = {
  options: arrayOf(shape({
    label: string,
    value: string,
  })),
  onChange: func,
  dataSelectorId: string,
};

SelectPanel.defaultProps = {
  options: [],
  onChange: undefined,
  dataSelectorId: undefined,
};

export default SelectPanel;
